import * as fromDatatype from '../datatype-library/index';

export interface app_mst_custom_field_item_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  logical_type: fromDatatype.VarcharDatatypeInterface;
  data_type: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  content_option_json: fromDatatype.JsonDatatypeInterface;
  content_validation_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_mst_custom_field_item_RowClass implements app_mst_custom_field_item_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  logical_type: fromDatatype.VarcharDatatypeInterface;
  data_type: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  content_option_json: fromDatatype.JsonDatatypeInterface;
  content_validation_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


